export enum RuleTargetType {
  SECTION = 'Section',
  FIELD = 'Field'
}
